import styled from 'styled-components';
import { PRIMARY_COLORS } from '../../../consts/colors';

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
`;

export const SignInButton = styled.button`
  background-color: ${PRIMARY_COLORS.FIRE_ENGINE_RED};
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
`;

export const ResetButton = styled.button`
  background-color: ${PRIMARY_COLORS.FIRE_ENGINE_RED};
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
`;